import isObject from 'lodash/isObject'

import React from 'react'
import clsx from 'clsx'

import { classToFComponent, type FCClassContext } from 'cube-react'

import { Container, BrLoading } from '@govbr-ds/react-components'

import Sel from './styles-consts'
import FiltroView from './v-filtro'
import CompareTableView from './v-table'

import { AnaliseBulasScope } from '../analise-bulas.scope'

export type AnaliseBulasProps = {
    className?: string
    scope: AnaliseBulasScope
}

class AnaliseBulasViewClass implements FCClassContext<AnaliseBulasProps> {
    scope!: AnaliseBulasScope

    render({ className, scope }: AnaliseBulasProps) {
        this.scope = scope

        const gradeElm = scope.loading ? (
            <div className={Sel.mLg('10xh')}>
                <BrLoading large label="Processando dados..." />
            </div>
        ) : (
            <CompareTableView className={Sel.mt('2xh')} scope={scope.table} />
        )

        return (
            <Container className={clsx(className)}>
                <div className={Sel.brCardHeader}>
                    <div className={Sel.dFlex}>
                        <div>
                            <div className={clsx(Sel.textWeightSemiBold, Sel.textUp02)}>
                                Análise Comparativa por Princípio Ativo
                            </div>
                            <div>Conferência de Reações Adversas e Conformidade Regulatória</div>
                        </div>
                    </div>
                </div>
                <br />
                <FiltroView scope={scope.filtro} />
                {gradeElm}
            </Container>
        )
    }
}

export default classToFComponent<AnaliseBulasProps>(AnaliseBulasViewClass)
